import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import {qrCodeService} from "../../services/qrCode.service";

const initialState = {
    session_id: null,
    photos: [],
    qr_code: null,
    uploadedPhotosFromDevice: [], //for user
    uploadedFilesFromDevice: [], //for db(type File)
    compressedFilesFromDevice: [],
    // True while QR-uploaded photos are still arriving from the phone or have
    // not finished loading in the browser. The order submit/next is blocked on
    // this so we never advance before every photo is actually synced+fetchable.
    photosSyncing: false,
}

const generate = createAsyncThunk('qrCodeSlice/generate',
    async () => {
        try {
            const res = await qrCodeService.generate();

            return res;
        } catch (error) {
            console.error(error);
            throw error;
        }
    });

const getPhotos = createAsyncThunk('qrCodeSlice/getPhotos',
    async ({session_id}) => {
        try {
            const res = await qrCodeService.getPhotos(session_id);

            return res;
        } catch (error) {
            console.error(error);
            throw error;
        }
    });

const qrCodeSlice = createSlice({
    name: 'qrCodeSlice',
    initialState,
    reducers: {
        setPhotos: (state, action) => {
            state.photos = action.payload;
        },
        setUploadedPhotosFromDevice: (state, action) => {
            state.uploadedPhotosFromDevice = action.payload;
        },
        setUploadedFilesFromDevice: (state, action) => {
            state.uploadedFilesFromDevice = action.payload;
        },
        setCompressedFilesFromDevice: (state, action) => {
            state.compressedFilesFromDevice = action.payload;
        },
        setPhotosSyncing: (state, action) => {
            state.photosSyncing = action.payload;
        },
        clearAllData: (state, action) => {
            state.uploadedPhotosFromDevice = [];
            state.uploadedFilesFromDevice = [];
            state.compressedFilesFromDevice = [];
            state.photos = [];
            state.session_id = null;
            state.qr_code = null;
            state.photosSyncing = false;
        }
    },
    extraReducers: builder => builder
        .addCase(generate.fulfilled, (state, action) => {
            const {qr_code, session_id} = action.payload;
            state.qr_code = qr_code;
            state.session_id = session_id;

            state.status = 'success';
        })
        .addCase(generate.pending, (state, action) => {
            state.status = 'loading';
        })

        .addCase(getPhotos.fulfilled, (state, action) => {
            state.photos = action.payload.photos;
        })
});

const {actions, reducer: qrCodeReducer} = qrCodeSlice;

const qrCodeActions = {
    ...actions,
    generate,
    getPhotos
}

export {
    qrCodeActions,
    qrCodeReducer,
}
